import { useQuery } from 'react-query';

import auth from '@udacity/ureact-hoth';

import { getAnonymousIdCookie } from '~/features/cookies/utils/get-anonymous-id-cookie';
import { getCouponCodeFromCookie } from '~/features/discount/utils/get-coupon-code-from-cookie';
import { Currency } from '~/features/internationalization/models/currency';
import { getViewerCurrency } from '~/features/internationalization/utils/get-viewer-currency';

import { getPricePlans } from '../controllers/get-price-plans';

export function usePricePlans(currency: Currency = getViewerCurrency()) {
  const anonymousId = getAnonymousIdCookie();
  const userId = auth.getCurrentUserId();
  const coupon = getCouponCodeFromCookie();

  return useQuery(
    ['pricing', currency, coupon ?? null],
    () => getPricePlans({ currency, anonymousId, userId, coupon }),
    {
      enabled: Boolean(currency),
    }
  );
}
